export function steps() {

	if ($(".Container__progress-bar__js").length > 0) {

		const infoItem = $(".Steps_info-items__js");
		const infoTitle = $(".Steps_info-title__js");
		const infoText = $(".Steps_info-text__js");
		let state = 0;
		let maxState = $(".cont span").length - 1;

		// Функция в которой прописанна выводимая информация на определенных шагах
		function makeUI() {
			if (state === 0) {
				$(".Steps_info-block.active_cont").animate({ opacity: 0 }, 100);
				$('#progress-bar').attr("value", "0")
			}

			else if (state === 1) {
				$(".Steps_info-block.active_cont").animate({ opacity: 0 }, 100);
				$('#progress-bar').attr("value", "20")
			}

			else if (state === 2) {
				$('#progress-bar').attr("value", "40")
				infoItem.animate({ opacity: 0 }, 100);
			}

			else if (state === 3) {
				$('#progress-bar').attr("value", "60")
				$(".Steps_info-block.active_cont").animate({ opacity: 0 }, 100);
			}

			else if (state === 4) {
				$('#progress-bar').attr("value", "80")
				$(".Steps_info-block.active_cont").animate({ opacity: 0 }, 100);
			}

			else if (state === 5) {
				$('#progress-bar').attr("value", "100")
				$(".Steps_info-block.active_cont").animate({ opacity: 0 }, 100);
			}

			setTimeout(() => {
				if (!$(".Steps_info-block[data-id=" + state + "]").hasClass('active_cont')) {
					$(".Steps_info-block.active_cont").removeClass('active_cont');
					$(".Steps_info-block[data-id=" + state + "]").addClass('active_cont');
				}
				$(".Steps_info-block[data-id=" + state + "]").animate({ opacity: 1 }, 100);
			}, 100);

			$(".state-active").removeClass("state-active");
			$(`.bar-item:eq(${state})`).addClass("state-active");
		}

		// изменение переменной состояния при клике на шаги "прогресс бара"
		$(".cont span").click(function () {
			$(this).prevAll().addClass("blue");
			$(this).nextAll().removeClass("blue");
			$(this).removeClass("blue");
			state = $(this).data("id");
			makeUI();
		});


		// анимация для мобильной версии
		function mobileStepAnim () {
			const progressBarContainer = $('.cont__js');

			if ($(window).width() <= '767') {
				let barItem = document.querySelectorAll('.bar-item__js');

				for (var i = 0; i < barItem.length; i++) {

					let currentBarPos

					// устанавливаем для прогрессбара позицию в зависимости от того на какой элемент нажали
					switch (i) {
						case 0: currentBarPos = "0%"; break;
						case 1: currentBarPos = "-5%"; break;
						case 2: currentBarPos = "-40%"; break;
						case 3: currentBarPos = "-60%"; break;
						case 4: currentBarPos = "-95%"; break;
						case 5: currentBarPos = "-105%"; break;
					}

					barItem[i].addEventListener('click', () => {
						progressBarContainer.css('left', currentBarPos);
					})
				}
			};
		}

		mobileStepAnim();

		$(window).resize(mobileStepAnim)
	};
};
